import {
  getProduct, parseAttributes, getGoogleClientId,
} from '@tracking/components/utils';
import { EVENT_NAMES, SKIP_SNAKE_CASE } from '@tracking/components/constants';
import CaseUtil from '@common/lib/caseUtil';
import { removeEmptyKeys } from '@common/utils/object';
import { getCookie } from '@common/utils/cookie';
import { getRequestSource, getDeviceType } from '@common/utils/platform';
import {
  getURLWithUTMParams,
  getUTMPropagationParams,
} from '@common/utils/url';

export function getGTMEventData(event, action, data, label, value, category) {
  const convertedData = SKIP_SNAKE_CASE.includes(event)
    ? data : CaseUtil.toCase('snakeCase', removeEmptyKeys(data));
  const company = window.GTMData?.company ?? null;
  const isLoggedIn = window.GTMData?.isLoggedIn ?? null;
  const region = window.GTMData?.region ?? null;
  const isFreeProductUser = window.GTMData?.isFreeProductUser ?? null;

  let pathName = window.location.pathname;
  let pageUrl = getURLWithUTMParams();
  let iframePageUrl;
  let referrerUrl;
  try {
    if (!(window === window.parent)) {
      const urlObj = new URL(window.parent.location);
      if (urlObj?.pathname) { pathName = urlObj.pathname; }
      pageUrl = window.parent.location;
      iframePageUrl = window.location.href;
    }
    referrerUrl = window.document.referrer
      ? new URL(window.document.referrer) : null;
  } catch (error) {
    // when in iframe the parent cannot be accessed because of
    // security reasons when domain is different.
  }
  const pagePath = pathName.endsWith('/') ? pathName : `${pathName}/`;
  const date = new Date();
  const dateOffset = date.getTimezoneOffset();
  const product = getProduct(pagePath, company);

  let attributes = {
    cu_date: date,
    cu_timezone_offset: dateOffset,
    region,
    user_analytics_identifier: getCookie('user_analytics_identifier'),
    google_client_id: getGoogleClientId(),
    request_source: getRequestSource(),
    isFreeProductUser,
    device: getDeviceType(),
    utm_propagation_params: getUTMPropagationParams(),
    ...window.TrackingHelper.getContext('ab_test'),
  };
  let userAttributes;
  if (event === EVENT_NAMES.SET_USER_ATTRIBUTE) {
    let userData = (window.TrackingHelper.getContext('user_data') || {});
    userData = {
      ...userData,
      cu_is_parent: window.GTMData?.cuIsUgStudent,
      cu_twelfth_graduation_year: window.GTMData?.cuTwelfthGradYear,
      cu_is_ug_enrolled: window.GTMData?.ugEnrolled === 'true',
    };
    attributes = {
      ...attributes,
      ...userData,
    };
    userAttributes = {
      ...userData,
      ...convertedData,
    };
  } else if (event === EVENT_NAMES.LEAD_FORM_ATTRIBUTION) {
    const formAttributionData = window.TrackingHelper.getContext(
      'lead_form_attribution_data',
    ) || {};

    attributes = {
      ...formAttributionData,
      ...window.TrackingHelper.getContext('ab_test'),
    };
  } else {
    attributes = {
      ...attributes,
      is_logged_in: isLoggedIn,
      page_url: pageUrl,
      page_path: pagePath,
      user_id: window.GTMData?.userId,
      iframePageUrl,
      iframe: !(window === window.parent),
      company,
      product,
      'referrer-url': referrerUrl?.href ?? null,
      'referrer-host': referrerUrl?.host ?? null,
    };
  }

  return {
    event,
    action,
    label,
    value,
    category,
    ...(userAttributes ? {
      user_attributes: parseAttributes(userAttributes),
    } : {}),
    attributes: parseAttributes({
      ...attributes,
      ...convertedData,
      ...(window.TrackingHelper.getContext('event_data') || {}),
      ...(window.TrackingHelper.getContext('mix_panel_data') || {}),
    }),
  };
}
